const { deleteCookie } = require('./delete-cookie')
const { getAllCookies } = require('./get-all-cookies')
const { getCookie } = require('./get-cookie')
const { getCookieSettings } = require('./get-cookie-settings')
const { setCookie } = require('./set-cookie')

module.exports = {
  deleteCookie,
  getAllCookies,
  getCookie,
  getCookieSettings,
  setCookie
}
